import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

/*
 * GraphQL Mutation for creating a quote change order.
 */
export const createQuoteChangeOrderMutation = gql`
  mutation quoteCOCreateQuoteChangeOrder(
    $description: String!,
    $businessType: QuoteCOChangeOrderBusiness!,
    $changeOrderType: QuoteCOChangeOrderType!,
    $purchaseOrderIds: [String!]!,
    $reasonForChange: String!,
    $rfqResponseId: ID,
    $rfqRevision: Int,
    $properties: [QuoteCOPropertyInput]
  ) {
    quoteCOCreateQuoteChangeOrder(
      description: $description,
      changeOrderType: $changeOrderType,
      businessType: $businessType,
      purchaseOrderIds: $purchaseOrderIds,
      reasonForChange: $reasonForChange,
      rfqResponseId: $rfqResponseId,
      rfqRevision: $rfqRevision,
      properties: $properties
    ) {
      changeOrderId
    }
  }
`;

interface CreateQuoteChangeOrderInput {
  description: string;
  businessType: string;
  changeOrderType: string;
  purchaseOrderIds: string[];
  reasonForChange: string;
  rfqResponseId?: string;
  rfqRevision?: number;
  properties?: Array<{
    name: string;
    value?: string;
  }>;
}

interface CreateQuoteChangeOrderResponse {
  quoteCOCreateQuoteChangeOrder: {
    changeOrderId: string;
  };
}

export async function createQuoteChangeOrder(
  client: ApolloClient<object>,
  input: CreateQuoteChangeOrderInput
): Promise<string> {
  try {
    const response = await client.mutate<CreateQuoteChangeOrderResponse>({
      mutation: createQuoteChangeOrderMutation,
      variables: {
        description: input.description,
        businessType: input.businessType,
        changeOrderType: input.changeOrderType,
        purchaseOrderIds: input.purchaseOrderIds,
        reasonForChange: input.reasonForChange,
        rfqResponseId: input.rfqResponseId,
        rfqRevision: input.rfqRevision,
        properties: input.properties
      }
    });

    if (!response.data) {
      throw new Error('No data returned from mutation');
    }

    return response.data.quoteCOCreateQuoteChangeOrder.changeOrderId;

  } catch (err) {
    throw new Error(`Failed to create quote change order: ${err}`);
  }
}
